// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"271":"05ac92cf","848":"cf7f8050"}[chunkId] + ".chunk.js";
};